import type { NavLink, SiteConfig } from '@/types'
import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: 'Forge',
    description: 'Forge is the autonomous engineer for production. It maps your systems, sorts every signal, ships fixes for review and proves they hold.',
    placeholder: 'Steady hands for production.',
    url: getOrigin()
}

export const productLinks: NavLink[] = [
    {
        label: 'How it works',
        href: '/#how-it-works',
        description: 'Map, triage, prioritize and resolve.'
    },
    {
        label: 'Watches',
        href: '/#watches',
        description: 'Scheduled agents that keep watch.'
    },
    {
        label: 'Context',
        href: '/#platform',
        description: 'Ownership, history and team decisions.'
    },
    {
        label: 'Command',
        href: '/#command',
        description: 'Ask, steer and work in your channels.'
    }
]

export const mainLinks: NavLink[] = [
    {
        label: 'Product',
        href: '/product'
    },
    {
        label: 'Customers',
        href: '/customers'
    },
    {
        label: 'Pricing',
        href: '/pricing'
    },
    {
        label: 'Company',
        href: '/about'
    },
    {
        label: 'Blog',
        href: '/research'
    }
]

export const footerColumns: { title: string, links: NavLink[] }[] = [
    {
        title: 'Product',
        links: [
            { label: 'Overview', href: '/product' },
            { label: 'How it works', href: '/#how-it-works' },
            { label: 'Watches', href: '/#watches' },
            { label: 'Pricing', href: '/pricing' }
        ]
    },
    {
        title: 'Company',
        links: [
            { label: 'About', href: '/about' },
            { label: 'Customers', href: '/customers' },
            { label: 'Research', href: '/research' },
            { label: 'Book a demo', href: '/demo' }
        ]
    },
    {
        title: 'Legal',
        links: [
            { label: 'Privacy', href: '/privacy' },
            { label: 'Terms', href: '/terms' }
        ]
    }
]
